import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import logo from '../../../../assets/logo.svg';
import logo_white from '../../../../assets/logo-white.svg';

import './styles.scss';
import '../../styles.scss';

const NotFoundPage = () => {
  const { t } = useTranslation('account');

  useEffect(() => {
    document.title = t('notFound.documentTitle');
  }, [t]);

  const setDefaultPageTitle = useCallback(() => {
    document.title = t('pageTitle');
  }, [t]);

  const isDarkMode =
    window.matchMedia('(prefers-color-scheme: dark)').matches || window.matchMedia('(color-scheme: dark)').matches;

  return (
    <div className="not-found-wrapper">
      <img className="error-logo-image" src={isDarkMode ? logo_white : logo} alt="Feller" />
      <h1 className="not-found-title">{t('notFound.title')}</h1>
      <p className="error-description">{t('notFound.description')}</p>
      <Link className="not-found-styled-link" to="/" onClick={setDefaultPageTitle}>
        {t('notFound.linkLabel')}
      </Link>
    </div>
  );
};

export default NotFoundPage;
